export default __webpack_public_path__ + "static/media/STL_Earnings_Call_Recording_December_2024.6b7a3962.mp3";